import { useCallback } from "react";
import { ErrorSeverity } from "../../error-handling/error-handler";
import { errorUI } from "../../error-handling/index";
import type { MainService } from "../../main-service";

interface UseSessionActionsParams {
	service: MainService | null;
}

interface ToggleFavoriteParams {
	sessionId: string;
	currentIsFavorite: boolean;
	onUpdated?: (nextIsFavorite: boolean) => void;
}

export const useSessionActions = ({ service }: UseSessionActionsParams) => {
	const toggleFavorite = useCallback(
		async ({
			sessionId,
			currentIsFavorite,
			onUpdated,
		}: ToggleFavoriteParams): Promise<boolean> => {
			if (!service) return false;

			try {
				const nextIsFavorite = !currentIsFavorite;
				await service.toggleFavoriteSession(sessionId, nextIsFavorite);
				onUpdated?.(nextIsFavorite);
				errorUI.showNotification(
					nextIsFavorite
						? "お気に入りに追加しました。"
						: "お気に入りを解除しました。",
					ErrorSeverity.LOW,
				);
				return true;
			} catch (_err) {
				errorUI.showNotification(
					"お気に入りの更新に失敗しました。",
					ErrorSeverity.HIGH,
				);
				return false;
			}
		},
		[service],
	);

	return {
		toggleFavorite,
	};
};
